import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { DataManager } from '@syncfusion/ej2-data';
import { TranslateService } from '@ngx-translate/core';
import { saveAs as importedSaveAs } from "file-saver";
import { HttpService } from '../../services/http.service';
import { HelperService } from '../../services/helper.service';
import { NotifyService } from '../../services/notify.service';
import { SidebarService } from '../../sidebar/sidebar.service';
import { AuthenService } from '../../services/authen.service';
import { Router } from '@angular/router';
import { UrlParams } from '../../helpers/url-params';
import { MasterBase } from '../../base/master-base';
import * as AppConst from '../../data/test.data';
import { MyImportFileDialogComponent } from "../../dialogs/my-import-file-dialog/my-import-file-dialog";
import { ChangeEventArgs } from '@syncfusion/ej2-buttons';
import { Util } from '../../helpers/global.util';

@Component({
    selector: 'hs-matrix-page',
    templateUrl: './hs-matrix-page.html',
})
export class HSMatrixPageComponent extends MasterBase implements OnInit, OnDestroy {
    @ViewChild('dlgImport') dlgImport: MyImportFileDialogComponent;
    waiting: boolean = false;
    requestTypeMList: any[] = [];
    requestTypesSelected: string[] = [];
    nameValueFields: Object = { text: 'Name', value: 'Value' };    

    constructor(auth: AuthenService, http: HttpService, helper: HelperService, notify: NotifyService, translate: TranslateService, private sidebar: SidebarService, private router: Router) {
        super(auth, http, helper, notify, translate);

        this.searchOpts = [
            { label: 'None', value: 0 },
            { label: 'User Code', value: 1 },
            { label: 'Request Type', value: 2 }
        ]
    }

    ngOnDestroy() {
    }

    ngOnInit() {
        this.onSearch();
        this.searchRequestTypes('');
    }

    onSearch() {
        let params = new UrlParams();
        params.add('hsUserCode', this.searchType == 1 ? (this.searchValue == null ? '' : this.searchValue) : '');
        params.add('groupRequestIds', this.searchType == 2 ? Util.array2String(this.requestTypesSelected) : '');

        this.gridData = this.http.getByManager(`api/Util/GetHSPage?${params.toString()}`, this.auth);
    }

    onExport() {
        let params = new UrlParams();
        params.add('hsUserCode', this.searchType == 1 ? (this.searchValue == null ? '' : this.searchValue) : '');
        params.add('groupRequestIds', this.searchType == 2 ? Util.array2String(this.requestTypesSelected) : '');
        this.waiting = true;
        this.http.download(`api/Util/ExportHSMatrix?${params.toString()}`, res => {
            let fileNameExport = 'CRM_HSMatrix.xlsx';
            importedSaveAs(res, fileNameExport);
            this.waiting = false;
        });
    }

    onImport() {
        this.dlgImport.show('api/Util/ImportHSMatrix', null, res => {
            this.grid.refresh();
        });
    }

    onDelete(id: number) {
        this.helper.confirm('Are you sure you want to remove this item ?', () => {
            this.http.delete(`api/Util/RemoveHSMatrix/${id}`, res => {
                this.grid.refresh();
            });
        });
    }

    searchRequestTypes(text: string) {
        this.http.get(`api/Util/SearchAllRequestTypeList?text=${text}`, res => {
            let tempList : any[] = [];
            res.Result.forEach(p => tempList.push({ 'Name': p.Name, 'Value': p.Value }));
            this.requestTypeMList = tempList;
            //console.log(this.requestTypeMList);
        });
    }

    onCheckAllRequestType(evt: ChangeEventArgs) {        
        if (evt.checked) {
            this.requestTypesSelected = [];
            this.requestTypeMList.forEach(p => {
                this.requestTypesSelected.push(p.Value);
            });
        } else {
            this.requestTypesSelected = [];
            console.log(this.requestTypesSelected);
        }
        //this.ngRefresh();
    }
}
